/**
 * Description: Registry for capability modules; behavior engine resolves active set from character + admin lists.
 * Usage: Instantiate per NanoNomad instance; register builtins or custom capabilities before start().
 */
export class CapabilityRegistry {
  constructor() {
    this._capabilities = Object.create(null);
  }

  register(id, definition) {
    const def = { ...definition, id };
    this._capabilities[id] = def;
  }

  get(id) {
    return this._capabilities[id] || null;
  }

  getAll() {
    return { ...this._capabilities };
  }

  has(id) {
    return !!this._capabilities[id];
  }

  resolve(characterCaps, enabledCaps) {
    const resolved = Object.create(null);
    const charList =
      characterCaps && characterCaps.length ? characterCaps : CapabilityRegistry.getDefaultList();

    for (let i = 0; i < charList.length; i++) {
      const id = charList[i];
      const cap = this._capabilities[id];
      if (!cap) continue;

      if (cap.system) {
        resolved[id] = cap;
        continue;
      }

      if (!enabledCaps || !enabledCaps.length || enabledCaps.indexOf(id) !== -1) {
        resolved[id] = cap;
      }
    }

    if (!resolved.idle && this._capabilities.idle) resolved.idle = this._capabilities.idle;
    if (!resolved.fall && this._capabilities.fall) resolved.fall = this._capabilities.fall;

    return resolved;
  }

  static getDefaultList() {
    return ['idle', 'walk', 'jump', 'sit', 'fall'];
  }
}
